export const DEFAULT_BOOK = "quotes"
